export const getLtlStepFromRoute = (pathname: string): number => {
	if (pathname.includes("/carrier-selection/")) {
		return 2;
	}
	return 1;
};
